module.exports = __webpack_public_path__ + "static/media/joe-theme.8949d9c3.wav";